module.exports = __webpack_public_path__ + "static/media/ai_small.de87491b.svg";